import * as _ from "lodash";
import { GET_INVENTORY_DETAIL_SUCCEEDED } from "./detail.action";

export const detail = (state = { fetched: false, data: {}, items: [] }, action) => {
  switch (action.type) {
    case GET_INVENTORY_DETAIL_SUCCEEDED:
      return action.data;

    default:
      return state;
  }
};
